<script setup lang="ts">
import { trans, transchoice } from '@elements/translation';
import type { SelectionItemOfficeOffer } from '@models/selectionItem.ts';
import Typography from '@components/Typography.vue';

defineProps<{ offers: SelectionItemOfficeOffer[] }>();
</script>

<template>
  <ul class="selection-item-multioffice-panel">
    <li
      v-for="offer in offers"
      :key="offer.hash_id"
    >
      <Typography variant="body-small">
        • {{ trans(`office_type.${offer.office_type.code}`) }}

        • {{ offer.capacity }} {{ transchoice('multioffice.capacity', { count: offer.capacity }) }}

        <template v-if="offer.surface">
          • {{ offer.surface }} {{ trans('global.area_unit.MTK') }}
        </template>
      </Typography>
    </li>
  </ul>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-multioffice-panel {
  padding-left: 0;
}
</style>
